import Vue from 'vue';
import VueCompositionAPI, { ref, unref } from '@vue/composition-api';
export var inBrowser = typeof window !== 'undefined';
export var isCompositionInstall = Object.hasOwnProperty.call(Vue, '__composition_api_installed__');

if (!isCompositionInstall) {
  Vue.use(VueCompositionAPI);
}

var width;
var height;
export function useWindowSize() {
  if (!width) {
    width = ref(0);
    height = ref(0);

    if (inBrowser) {
      var update = function update() {
        width.value = window.innerWidth;
        height.value = window.innerHeight;
      };

      update();
      window.addEventListener('resize', update, {
        passive: true
      });
      window.addEventListener('orientationchange', update, {
        passive: true
      });
    }
  }

  return {
    width: width,
    height: height
  };
}

var _useWindowSize = useWindowSize(),
    windowWidth = _useWindowSize.width,
    windowHeight = _useWindowSize.height;

export { windowWidth, windowHeight };
export function isHidden(elementRef) {
  var el = unref(elementRef);

  if (!el) {
    return false;
  }

  var style = window.getComputedStyle(el);
  var hidden = style.display === 'none'; // offsetParent returns null in the following situations:
  // 1. The element or its parent element has the display property set to none.
  // 2. The element has the position property set to fixed

  var parentHidden = el.offsetParent === null && style.position !== 'fixed';
  return hidden || parentHidden;
}
export function getScrollTop(el) {
  var top = 'scrollTop' in el ? el.scrollTop : el.pageYOffset; // const top =  el.pageYOffset;
  // iOS scroll bounce cause minus scrollTop

  return Math.max(top, 0);
}
export function getRootScrollTop() {
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
}
export function setScrollTop(el, value) {
  if ('scrollTop' in el) {
    el.scrollTop = value;
  } else {
    el.scrollTo(el.scrollX, value);
  }
}
export function setRootScrollTop(value) {
  setScrollTop(window, value);
  setScrollTop(document.body, value);
}
export var stopPropagation = function stopPropagation(event) {
  return event.stopPropagation();
};
export function preventDefault(event, isStopPropagation) {
  /* istanbul ignore else */
  if (typeof event.cancelable !== 'boolean' || event.cancelable) {
    event.preventDefault();
  }

  if (isStopPropagation) {
    stopPropagation(event);
  }
}
export var isIOS = function isIOS() {
  return inBrowser ? /ios|iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase()) : false;
};
export function resetScroll() {
  if (isIOS()) {
    setRootScrollTop(getRootScrollTop());
  }
}